/* eslint-disable */
import React from 'react';
import { Container, Row, Col } from 'reactstrap';

const Footer = () => {
    const fecha = new Date();

    return (
        <div className="footer4 b-t spacer">
            <Container>
                <Row>
                    <Col lg="3" md="6" className="m-b-30">
                        <h5 className="m-b-20">Dirección</h5>
                        <p>-</p>
                        <p>-</p>
                    </Col>
                    <Col lg="3" md="6" className="m-b-30">
                        <h5 className="m-b-20">Teléfono</h5>
                        <p>Celular :  - </p>
                    </Col>
                    <Col lg="3" md="6" className="m-b-30">
                        <h5 className="m-b-20">Email</h5>
                        <p><a href="#" className="link"> - </a> 
                        </p>
                    </Col>
                    <Col lg="3" md="6" >
                        <h5 className="m-b-20">Redes Sociales</h5>
                        <div className="round-social light">
                            <a href="https://web.facebook.com/" className="link"><i className="fa fa-facebook"></i></a>
                            <a href="https://twitter.com/" className="link"><i className="fa fa-twitter"></i></a>
                        </div>
                    </Col>
                </Row>
                <div className="f4-bottom-bar">
                    <Row>
                        <Col md="12">
                            <div className="d-flex font-14">
                                <div className="m-t-10 m-b-10 copyright"></div>
                                <div className="links ml-auto m-t-10 m-b-10">
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="layout-footer">
                    <img src="/logos/clioydike.png" alt="Logo" height="25" className="mr-2" />
                    <span className="m-t-10 m-b-10 copyright" >Ing. Jheyson Gaitan - {fecha.getFullYear()} ©</span>
                </div>
            </Container>
        </div>
    );
}
export default Footer;
